/* eslint-disable no-unneeded-ternary */
import React from 'react';
import { connect } from 'react-redux';
import { Table, Input, Dropdown, Button, TextArea, Checkbox } from 'semantic-ui-react';
import * as action from '../../../actions/newYouslim';
import { toastError } from '../../../utils/toastMessage';
import TagsBlock from '../TagsBlock';
import {
  H1,
  H2,
  TableBlock,
  ProductNameBlock,
  Label,
  ButtonBlock,
  FooterBlock,
  AllTagsBlock,
  AllTagBlock,
  TitleOfCbju,
  RecipeBlock,
  RecipeButtonBlock,
  RecipeListBlock,
  RecipeDescription,
  RecipeContentBlock,
  StepTitle,
  UploadedPhoto,
  AddPhotoBlock,
  Recipe,
  RecipenCookingTime,
  PreviewImage,
  IsDraftCheckboxBlock,
} from './CreateDishStyles';
import {
  dish_tags_id,
  eating_tags_id,
  defualt_portion,
  defaultProductRow,
  tasteValue,
} from '../youslim2.0_Constants';
import { LinkBlock, StyledLink } from '../CreateProductPage/CreateProductStyles';
import Navbar from '../Navigation/Navbar';

const cbjuTitle = ['К', 'Б', 'Ж', 'У'];

const CreateDishPage = React.memo(
  ({
    match,
    getRecipeTags,
    allRecipeTags,
    createRecipe,
    getProductsByName,
    products,
    getEatingTags,
    allEatingTags,
    currentDish,
    updateRecipe,
    getProductsListByName,
    setCurrentDish,
    getDishById,
    isDishLoading,
  }) => {
    const addCurrentProductsRows = () => {
      currentDish.products &&
        currentDish.products.length &&
        currentDish.products.map((product) => {
          // eslint-disable-next-line no-return-assign
          return [
            ...product,
            product.animal_protein &&
              (product.proteins = +product.animal_protein + +product.vegetable_protein),
            product.unsaturated_fats &&
              (product.fats = +product.unsaturated_fats + +product.saturated_fat),
            product.simple_carbohydrates &&
              (product.carbohydrates =
                +product.simple_carbohydrates + +product.complex_carbohydrates),
          ];
        });
    };
    const [productsRows, setProductsRows] = React.useState(
      (currentDish && currentDish.products && addCurrentProductsRows()) || [
        { ...defaultProductRow },
      ],
    );
    const [isAddProduct, setIsAddProduct] = React.useState(true); // this state need for re-render current state

    const searchTags = (allTags) => {
      const newTags = [];
      currentDish.tags.forEach((tag) => {
        let isTagsHere = false;
        allTags.forEach((recipeTag) => {
          if (recipeTag.id === tag.id) {
            isTagsHere = true;
          }
        });
        if (isTagsHere) return newTags.push(tag.id);
      });
      return newTags;
    };
    const [choosedTags, setChoosedTags] = React.useState(
      (currentDish.tags && searchTags(allRecipeTags)) || [],
    );
    const [recipeName, setRecipeName] = React.useState(currentDish.title || '');
    const [productList, setProductList] = React.useState([]);
    const [choosedEatingTags, setChoosedEatingTags] = React.useState(
      (currentDish.tags && searchTags(allEatingTags)) || [],
    );
    const [currentListIndex, setCurrentListIndex] = React.useState(0);
    const [tagsList, setTagsList] = React.useState([]);
    const [generalCBJUForSmallPortion, setGeneralCBJUForSmallPortion] = React.useState(0);
    const [generalCBJUForMediumPortion, setGeneralCBJUForMediumPortion] = React.useState(0);
    const [generalCBJUForBigPortion, setGeneralCBJUForBigPortion] = React.useState(0);
    const [generalCBJUForLargePortion, setGeneralCBJUForLargePortion] = React.useState(0);
    const [recipeList, setRecipeList] = React.useState(
      currentDish.dish_recipes && !!currentDish.dish_recipes.length
        ? currentDish.dish_recipes
        : [''],
    );
    const [isDraft, setIsDraft] = React.useState(currentDish.is_draft ? true : false);
    const [recipeDescription, setRecipeDescription] = React.useState(currentDish.description || '');
    const [uploadedPhoto, setUploadedPhoto] = React.useState(currentDish.photo || '');
    const [recipeCookingTime, setRecipeCookingTime] = React.useState(
      currentDish.cooking_time || '',
    );

    const onClearRecipe = React.useCallback(() => {
      setRecipeName('');
      setChoosedTags([]);
      setChoosedEatingTags([]);
      setProductsRows([{ ...defaultProductRow }]);
      setRecipeCookingTime('');
      setUploadedPhoto('');
      setRecipeDescription('');
      setRecipeList(['']);
      document.getElementById('file-input').value = '';
    }, [setRecipeName, setChoosedTags, setChoosedEatingTags, setProductsRows, defaultProductRow]);

    React.useEffect(() => {
      getProductsByName();
      getRecipeTags(dish_tags_id);
      getEatingTags(eating_tags_id);
      const dishId = match && match.params && match.params.id;
      if (dishId) {
        getDishById(dishId);
      } else {
        onClearRecipe();
      }
      return () => {
        onClearRecipe();
        setCurrentDish({});
      };
    }, []);

    const sortProductByAlphabet = (oldProductsList, newProductsItems) => {
      // eslint-disable-next-line no-unused-expressions
      oldProductsList.sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });

      oldProductsList.forEach((product) => {
        newProductsItems.push({
          key: product.id,
          value: product.id,
          text: product.name,
          measure: product.measure,
          tags: product.tags,
          calories: product.calories,
          proteins: +product.animal_protein + +product.vegetable_protein,
          fats: +product.unsaturated_fats + +product.saturated_fat,
          carbohydrates: +product.simple_carbohydrates + +product.complex_carbohydrates,
        });
      });
    };

    React.useEffect(() => {
      const newProductsItems = [];
      const newProductsList = productList;
      const oldProductsList = products;
      sortProductByAlphabet(oldProductsList, newProductsItems);
      newProductsList[currentListIndex] = newProductsItems;
      setProductList([...newProductsList]);
    }, [products, setProductList, currentListIndex, setCurrentListIndex]);

    React.useEffect(() => {
      if (currentDish.products) {
        setRecipeName(currentDish.title);
        setProductsRows(currentDish.products);
        setChoosedTags(currentDish.tags && searchTags(allRecipeTags));
        setChoosedEatingTags(currentDish.tags && searchTags(allEatingTags));
        currentDish.products.length &&
          currentDish.products.forEach((product, index) => {
            const newProductsList = productList;
            getProductsListByName(
              product.name,
              productList,
              sortProductByAlphabet,
              newProductsList,
              index,
              setProductList,
            );
          });
        setRecipeList(
          currentDish.dish_recipes && !!currentDish.dish_recipes.length
            ? currentDish.dish_recipes
            : [''],
        );
        setRecipeDescription(currentDish.description || '');
        setUploadedPhoto(currentDish.photo || '');
        setRecipeCookingTime(currentDish.cooking_time || '');
        setIsDraft(currentDish.is_draft ? true : false);
      } else {
        onClearRecipe();
      }
    }, [currentDish]);

    const onSearchUniqueTags = () => {
      const newProductsTags = [];
      let isTagsUnique = true;
      productsRows.forEach((product) => {
        if (product && product.tags && product.tags.length) {
          product.tags.forEach((tag) => {
            if (
              !newProductsTags.forEach((newProductsTag) => {
                if (newProductsTag.id === tag.id) isTagsUnique = false;
              })
            ) {
              if (isTagsUnique) newProductsTags.push(tag);
              isTagsUnique = true;
            }
          });
        }
      });
      setTagsList(newProductsTags);
    };

    React.useEffect(() => {
      onSearchUniqueTags();
      defualt_portion.forEach((portion) => {
        // eslint-disable-next-line no-use-before-define
        onGeneralCBJUChange(portion.value);
      });
    }, [productsRows]);

    React.useEffect(() => {
      if (allEatingTags.length && currentDish.tags) setChoosedEatingTags(searchTags(allEatingTags));
    }, [allEatingTags, currentDish]);

    React.useEffect(() => {
      if (allRecipeTags.length && currentDish.tags) setChoosedTags(searchTags(allRecipeTags));
    }, [allRecipeTags, currentDish]);

    const onAddProductRow = () => {
      const product = productsRows;
      product.push({ ...defaultProductRow });
      getProductsByName();
      setCurrentListIndex(product.length - 1);
      setProductsRows([...product]);
    };

    const onAddNewStep = React.useCallback(() => {
      setRecipeList([...recipeList, '']);
    }, [recipeList, setRecipeList]);

    const onRemoveStep = React.useCallback(
      (index) => {
        const newRecipeList = [...recipeList];

        newRecipeList.splice(index, 1);
        setRecipeList([...newRecipeList]);
      },
      [recipeList, setRecipeList],
    );

    const onChangeStep = (index, value) => {
      recipeList[index] = value;
      setIsAddProduct(!isAddProduct);
    };

    const onDeleteProductRow = (i) => {
      const product = [...productsRows];
      const newPorductList = [...productList];
      product.splice(i, 1);
      newPorductList.splice(i, 1);
      setProductsRows([...product]);
      setProductList([...newPorductList]);
    };

    const onGeneralCBJUChange = React.useCallback(
      (portionName) => {
        let generalC = 0;
        let generalB = 0;
        let generalJ = 0;
        let generalU = 0;
        productsRows.forEach((product) => {
          if (product[portionName] > 0) {
            if (
              product.measure === 'ч.л.' ||
              product.measure === 'ст.л.' ||
              product.measure === 'шт.'
            ) {
              generalC += product.calories * product[portionName];
              generalB += product.proteins * product[portionName];
              generalJ += product.fats * product[portionName];
              generalU += product.carbohydrates * product[portionName];
            } else {
              generalC += (product.calories * product[portionName]) / 100;
              generalB += (product.proteins * product[portionName]) / 100;
              generalJ += (product.fats * product[portionName]) / 100;
              generalU += (product.carbohydrates * product[portionName]) / 100;
            }
          }
        });

        const generalCBJUForPortion = [
          generalC.toFixed(1),
          generalB.toFixed(1),
          generalJ.toFixed(1),
          generalU.toFixed(1),
        ]; // : generalCBJU.toFixed(1);

        if (portionName === 'small') {
          setGeneralCBJUForSmallPortion(generalCBJUForPortion);
        } else if (portionName === 'medium') {
          setGeneralCBJUForMediumPortion(generalCBJUForPortion);
        } else if (portionName === 'big') {
          setGeneralCBJUForBigPortion(generalCBJUForPortion);
        } else if (portionName === 'large') {
          setGeneralCBJUForLargePortion(generalCBJUForPortion);
        }
      },
      [
        setGeneralCBJUForSmallPortion,
        setGeneralCBJUForMediumPortion,
        setGeneralCBJUForBigPortion,
        setGeneralCBJUForLargePortion,
        productsRows,
      ],
    );

    const onChangeProduct = (data, i) => {
      let isIdenticalDishesFound = false;
      productsRows.forEach((product) => {
        if (product.product_id === data.value) {
          productsRows[i].error = true;
          isIdenticalDishesFound = true;
        }
      });
      if (isIdenticalDishesFound === false) productsRows[i].error = false;
      productsRows[i].product_id = data.value;
      productList[i].forEach((product) => {
        if (product.value === data.value) {
          productsRows[i].measure = product.measure;
          productsRows[i].tags = product.tags;
          productsRows[i].calories = product.calories;
          productsRows[i].proteins = product.proteins;
          productsRows[i].fats = product.fats;
          productsRows[i].carbohydrates = product.carbohydrates;
        }
      });
      setIsAddProduct(!isAddProduct);
      onSearchUniqueTags();
      defualt_portion.forEach((portion) => {
        onGeneralCBJUChange(portion.value);
      });
    };

    const onChangeSmallPortion = React.useCallback(
      (data, i) => {
        const products = productsRows;
        products[i].small = data.value;
        setProductsRows([...products]);
        onGeneralCBJUChange('small');
      },
      [productsRows, onGeneralCBJUChange, setIsAddProduct, isAddProduct],
    );

    const onChangeMediumPortion = React.useCallback(
      (data, i) => {
        const products = productsRows;
        products[i].medium = data.value;

        setProductsRows([...products]);
        onGeneralCBJUChange('medium');
      },
      [productsRows, onGeneralCBJUChange, setIsAddProduct, isAddProduct],
    );

    const onChangeIncreasedPortion = React.useCallback(
      (data, i) => {
        const products = productsRows;
        products[i].big = data.value;
        setProductsRows([...products]);
        onGeneralCBJUChange('big');
      },
      [productsRows, onGeneralCBJUChange, setIsAddProduct, isAddProduct],
    );

    const onChangeLargePortion = React.useCallback(
      (data, i) => {
        const products = productsRows;
        products[i].large = data.value;
        setProductsRows([...products]);
        onGeneralCBJUChange('large');
      },
      [productsRows, onGeneralCBJUChange, setIsAddProduct, isAddProduct],
    );

    const handleUploadPhoto = React.useCallback(
      (e) => {
        const file = e.target.files[0];
        setUploadedPhoto(file);
      },
      [setUploadedPhoto],
    );

    const checkRecipeStepToEmptyFields = () => {
      if (recipeList.length && recipeList[0] === '') return [];
      const newRecipeList = [];
      recipeList.forEach((step) => {
        if (step) newRecipeList.push(step);
      });
      return newRecipeList;
    };

    const onSaveRecipe = () => {
      const productsValue = productsRows;
      let isProductNameEmpty = false;
      let isProductEmpty = false;
      let isPortionEmpty = false;
      let isPortionIncorrect = false;
      let isIdenticalDishesFound = false;

      if (!recipeName) {
        isProductNameEmpty = true;
      }
      productsValue.forEach((row) => {
        if (!row.product_id) {
          isProductEmpty = true;
        }
        if (row.error === true) {
          isIdenticalDishesFound = true;
        }
        if (row.measure !== tasteValue) {
          if (row.small <= 0 || row.medium <= 0 || row.big <= 0 || row.large <= 0) {
            isPortionEmpty = true;
          }

          if (
            +row.medium < +row.small ||
            +row.big < +row.small ||
            +row.large < +row.small ||
            +row.big < +row.medium ||
            +row.large < +row.medium ||
            +row.large < +row.big
          ) {
            isPortionIncorrect = true;
          }
        }
      });
      if (isProductNameEmpty) {
        toastError('Название блюда не заполнено');
        return;
      }
      if (isProductEmpty || isPortionEmpty) {
        toastError('Не все поля заполнены');
        return;
      }
      if (isPortionIncorrect) {
        toastError('Вес порции должен быть больше или равен меньшей порции');
        return;
      }
      if (!choosedTags.length) {
        toastError('Теги не выбраны');
        return;
      }
      if (!choosedEatingTags.length) {
        toastError('Приём пищи не выбран');
        return;
      }
      if (isIdenticalDishesFound) {
        toastError('Выбраны одинаковые продукты');
        return;
      }

      const recipeSteps = checkRecipeStepToEmptyFields();
      const recipes = { small: [], medium: [], big: [], large: [] };
      productsRows.forEach((row) => {
        let isRoundToNearestInteger = false;
        const productValue = products.find((product) => product.id === row.product_id);
        if (
          productValue.measure === 'ст.л.' ||
          productValue.measure === 'ч.л.' ||
          productValue.measure === 'шт'
        ) {
          isRoundToNearestInteger = true;
        }
        if (productValue.measure === tasteValue) {
          recipes.small.push({
            product_id: row.product_id,
            quantity: 0,
          });
          recipes.medium.push({
            product_id: row.product_id,
            quantity: 0,
          });
          recipes.big.push({
            product_id: row.product_id,
            quantity: 0,
          });
          recipes.large.push({
            product_id: row.product_id,
            quantity: 0,
          });
        } else {
          recipes.small.push({
            product_id: row.product_id,
            quantity: isRoundToNearestInteger
              ? Math.ceil(+row.small)
              : Math.round(+row.small * 10) / 10,
          });
          recipes.medium.push({
            product_id: row.product_id,
            quantity: isRoundToNearestInteger
              ? Math.ceil(+row.medium)
              : Math.round(+row.medium * 10) / 10,
          });
          recipes.big.push({
            product_id: row.product_id,
            quantity: isRoundToNearestInteger
              ? Math.ceil(+row.big)
              : Math.round(+row.big * 10) / 10,
          });
          recipes.large.push({
            product_id: row.product_id,
            quantity: isRoundToNearestInteger
              ? Math.ceil(+row.large)
              : Math.round(+row.large * 10) / 10,
          });
        }
      });
      if (
        !isProductNameEmpty &&
        !isProductEmpty &&
        !isPortionEmpty &&
        !isPortionIncorrect &&
        !isIdenticalDishesFound &&
        choosedTags.length &&
        choosedEatingTags.length
      ) {
        const recipe = {
          title: recipeName,
          recipes: recipes,
          tags: [...choosedTags, ...choosedEatingTags],
        };
        if (recipeSteps) recipe.recipes_text = recipeSteps;
        if (recipeDescription) recipe.description = recipeDescription;
        if (uploadedPhoto) recipe.file = uploadedPhoto;
        if (recipeCookingTime) recipe.cooking_time = recipeCookingTime;
        if (currentDish.products) {
          recipe.is_draft = isDraft;
          updateRecipe(recipe, currentDish.id);
        } else {
          createRecipe(recipe, onClearRecipe);
        }
      }
    };

    return (
      <React.Fragment>
        <Navbar />
        <H1>{currentDish.id ? 'Pедактирование блюда' : 'Создание блюда'}</H1>
        <H2>Необходимо заполнить состав продуктов в блюде для всех 4 объёмов порций!</H2>
        <ProductNameBlock>
          <Label>Название блюда</Label>
          <Input
            className="product-name-input"
            placeholder="Введите название блюда"
            value={recipeName}
            onChange={(e) => setRecipeName(e.target.value)}
          />
          {currentDish.id && (
            <IsDraftCheckboxBlock>
              <Checkbox
                toggle
                label="Черновик"
                defaultChecked={currentDish.is_draft ? true : false}
                value={isDraft}
                onChange={() => setIsDraft(!isDraft)}
              />
            </IsDraftCheckboxBlock>
          )}
        </ProductNameBlock>
        <TableBlock>
          <Table definition celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell>
                  Маленькая порция
                  <br />
                  {!!generalCBJUForSmallPortion && (
                    <div>
                      <TitleOfCbju>
                        {cbjuTitle.map((title) => (
                          <p>{title}</p>
                        ))}
                      </TitleOfCbju>
                      <TitleOfCbju>
                        {generalCBJUForSmallPortion.map((value, i) => (
                          <p>{value}</p>
                        ))}
                      </TitleOfCbju>
                    </div>
                  )}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  Средняя порция
                  <br />
                  {!!generalCBJUForMediumPortion && (
                    <div>
                      <TitleOfCbju>
                        {cbjuTitle.map((title) => (
                          <p>{title}</p>
                        ))}
                      </TitleOfCbju>
                      <TitleOfCbju>
                        {generalCBJUForMediumPortion.map((value, i) => (
                          <p>{value}</p>
                        ))}
                      </TitleOfCbju>
                    </div>
                  )}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  Увеличенная порция
                  <br />
                  {!!generalCBJUForBigPortion && (
                    <div>
                      <TitleOfCbju>
                        {cbjuTitle.map((title) => (
                          <p>{title}</p>
                        ))}
                      </TitleOfCbju>
                      <TitleOfCbju>
                        {generalCBJUForBigPortion.map((value, i) => (
                          <p>{value}</p>
                        ))}
                      </TitleOfCbju>
                    </div>
                  )}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  Большая порция
                  <br />
                  {!!generalCBJUForLargePortion && (
                    <div>
                      <TitleOfCbju>
                        {cbjuTitle.map((title) => (
                          <p>{title}</p>
                        ))}
                      </TitleOfCbju>
                      <TitleOfCbju>
                        {generalCBJUForLargePortion.map((value, i) => (
                          <p>{value}</p>
                        ))}
                      </TitleOfCbju>
                    </div>
                  )}
                </Table.HeaderCell>
                <Table.HeaderCell>Мера веса</Table.HeaderCell>
              
                <Table.HeaderCell />
             
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {productsRows.map((product, i) => (
                <Table.Row key={Math.random()}>
                  <Table.Cell>
                    <Dropdown
                      placeholder="Выберите продукт"
                      id="choose-product-input"
                      fluid
                      search
                      selection
                      options={productList[i]}
                      value={productsRows[i].product_id}
                      onChange={(e, data) => onChangeProduct(data, i)}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      className="product-name-input"
                      placeholder="Введите вес продукта"
                      disabled={productsRows[i].measure === tasteValue}
                      type="number"
                      defaultValue={productsRows[i].small}
                      onBlur={(e) => onChangeSmallPortion(e.target, i)}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      className="product-name-input"
                      placeholder="Введите вес продукта"
                      type="number"
                      disabled={productsRows[i].measure === tasteValue}
                      defaultValue={productsRows[i].medium}
                      onBlur={(e) => onChangeMediumPortion(e.target, i)}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      className="product-name-input"
                      placeholder="Введите вес продукта"
                      type="number"
                      disabled={productsRows[i].measure === tasteValue}
                      defaultValue={productsRows[i].big}
                      onBlur={(e) => onChangeIncreasedPortion(e.target, i)}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      className="product-name-input"
                      placeholder="Введите вес продукта"
                      type="number"
                      disabled={productsRows[i].measure === tasteValue}
                      defaultValue={productsRows[i].large}
                      onBlur={(e) => onChangeLargePortion(e.target, i)}
                    />
                  </Table.Cell>
                  <Table.Cell>{productsRows[i].measure}</Table.Cell>
  
                  <Table.Cell>
                    <Button negative onClick={() => onDeleteProductRow(i)}>
                      Удалить
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
              <Table.Row>
                <Table.Cell>
                  <Button positive onClick={onAddProductRow}>
                    Добавить
                  </Button>
                </Table.Cell>
                <Table.Cell colSpan="5">{tagsList.map((tag) => ` ${tag.name} `)}</Table.Cell>
                
                <Table.Cell />
              </Table.Row>
            </Table.Body>
          </Table>
        </TableBlock>
        <Recipe>
          <H2>Описание приготовления</H2>
          <RecipeBlock>
            <RecipeDescription>
              <p>Описание блюда</p>
              <TextArea
                placeholder="Опишите блюдо"
                value={recipeDescription}
                onChange={(e) => setRecipeDescription(e.target.value)}
                style={{ width: '100%', height: '100px' }}
              />
            </RecipeDescription>
            <RecipeListBlock>
              {recipeList.map((step, index) => {
                const newRecipeList = [...recipeList];
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <RecipeContentBlock key={`${step} + ${index}`}>
                    <StepTitle>{`Шаг ${index + 1}`}</StepTitle>
                    <TextArea
                      placeholder="Опишите процесс приготовления"
                      defaultValue={step}
                      onBlur={(e) => onChangeStep(index, e.target.value, newRecipeList)}
                      style={{ width: '70%', minHeight: '100px' }}
                    />
                    <RecipeButtonBlock>
                      <Button positive onClick={onAddNewStep} style={{ marginBottom: '5px' }}>
                        +
                      </Button>
                      {index > 0 && (
                        <Button negative onClick={() => onRemoveStep(index)}>
                          -
                        </Button>
                      )}
                    </RecipeButtonBlock>
                  </RecipeContentBlock>
                );
              })}
            </RecipeListBlock>
          </RecipeBlock>
        </Recipe>
        <RecipenCookingTime>
          <p>Время приготовления</p>
          <Input
            placeholder="Введите время приготовления"
            value={recipeCookingTime}
            onChange={(e) => setRecipeCookingTime(e.target.value)}
            style={{ width: '100%' }}
          />
        </RecipenCookingTime>
        <H2>Выберите фото для блюда</H2>

        <AddPhotoBlock>
          {uploadedPhoto && uploadedPhoto.name !== '' && (
            <div>
              {!uploadedPhoto.name && (
                <PreviewImage>
                  <img src={uploadedPhoto} alt="dishPhoto" />
                </PreviewImage>
              )}
              <UploadedPhoto>
                {`Загружено фото: ${
                  uploadedPhoto.name ? uploadedPhoto.name : uploadedPhoto
                }, загрузить другое?`}
              </UploadedPhoto>
            </div>
          )}

          <input id="file-input" type="file" name="file" multiple onChange={handleUploadPhoto} />
        </AddPhotoBlock>
        <AllTagsBlock>
          <AllTagBlock>
            <H2>Приём пищи</H2>
            <TagsBlock
              allTags={allEatingTags}
              choosedTags={choosedEatingTags}
              setChoosedTags={setChoosedEatingTags}
              width="100%"
            />
          </AllTagBlock>
          <AllTagBlock>
            <H2>Теги блюда</H2>
            <TagsBlock
              allTags={allRecipeTags}
              choosedTags={choosedTags}
              setChoosedTags={setChoosedTags}
              width="100%"
            />
          </AllTagBlock>
        </AllTagsBlock>
        <ButtonBlock>
          <Button positive onClick={onSaveRecipe} loading={isDishLoading}>
            Сохранить
          </Button>
          <Button onClick={onClearRecipe}>Очистить</Button>
        </ButtonBlock>
        <FooterBlock />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const { allRecipeTags, products, allEatingTags, currentDish, isDishLoading } = state.newYouslim;
  return {
    allRecipeTags,
    products,
    allEatingTags,
    currentDish,
    isDishLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRecipeTags: (tags) => {
      dispatch(action.getRecipeTags(tags));
    },
    getDishById: (id) => {
      dispatch(action.getDishById(id));
    },
    getEatingTags: (tags) => {
      dispatch(action.getEatingTags(tags));
    },
    createRecipe: (data, clear) => {
      dispatch(action.createRecipe(data, clear));
    },
    updateRecipe: (data, id, clear) => {
      dispatch(action.updateRecipe(data, id, clear));
    },
    getProductsByName: (name) => {
      dispatch(action.getProductsByName(name));
    },
    setCurrentDish: (product) => {
      dispatch(action.setCurrentDish(product));
    },
    getProductsListByName: (
      name,
      products,
      sortProductByAlphabet,
      newProductsList,
      index,
      setProductList,
      setIsAddProduct,
      isAddProduct,
    ) => {
      dispatch(
        action.getProductsListByName(
          name,
          products,
          sortProductByAlphabet,
          newProductsList,
          index,
          setProductList,
          setIsAddProduct,
          isAddProduct,
        ),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDishPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateDishPage/index.jsx